import React from 'react';

function rainy() {
  return (
    <div>
      <svg width="160" height="222" viewBox="0 0 160 222" fill="none">
        <g style={{ 'mix-blend-mode': 'multiply' }}>
          <path
            opacity="0.032258"
            d="M54.1091 6.60487C77.3138 5.15458 123.723 55.9148 119.372 89.2715C115.021 129.88 65.7115 137.131 42.5068 129.88C16.4016 121.178 6.24951 96.5229 6.24951 82.02C4.79922 58.8154 33.805 8.05516 54.1091 6.60487Z"
            fill="#FBFCFC"
          />
          <path
            opacity="0.064516"
            d="M54.1091 6.60488C75.8635 5.15459 122.273 54.4645 117.922 87.8212C113.571 128.429 65.7115 135.681 42.5068 128.429C16.4016 121.178 6.24951 95.0726 6.24951 82.02C4.79922 58.8154 33.805 8.05517 54.1091 6.60488Z"
            fill="#F7F9FA"
          />
          <path
            opacity="0.096774"
            d="M54.1094 8.05518C75.8638 6.60489 119.373 54.4645 116.472 87.8212C110.671 126.979 65.7118 134.231 42.5071 126.979C17.8521 119.728 7.70011 95.0726 6.24982 82.02C6.24982 58.8154 33.8053 9.50547 54.1094 8.05518Z"
            fill="#F3F6F7"
          />
          <path
            opacity="0.129"
            d="M52.6589 8.05518C72.963 6.60489 116.472 54.4645 113.571 86.3709C109.22 124.078 64.2612 131.33 41.0566 125.529C17.8519 118.277 7.69989 93.6224 7.69989 80.5697C6.2496 58.8154 33.8051 9.50547 52.6589 8.05518Z"
            fill="#EFF3F5"
          />
          <path
            opacity="0.1613"
            d="M52.6588 9.50547C72.9629 8.05518 115.021 54.4645 112.121 86.3709C107.77 122.628 64.2611 131.33 42.5068 124.078C17.8518 116.827 9.15006 93.6224 7.69977 80.5697C7.69977 58.8154 33.805 10.9558 52.6588 9.50547Z"
            fill="#EBF0F2"
          />
          <path
            opacity="0.1935"
            d="M52.6588 10.9558C72.9629 9.50547 113.571 55.9148 110.67 86.3709C106.32 122.628 64.2611 129.88 42.5068 124.078C17.8518 116.827 9.15006 92.1721 9.15006 80.5697C7.69977 58.8154 33.805 12.4061 52.6588 10.9558Z"
            fill="#E8EDF0"
          />
          <path
            opacity="0.2258"
            d="M51.2086 10.9558C70.0623 9.50548 110.67 54.4645 107.77 84.9206C103.419 119.728 62.8109 128.429 41.0565 121.178C17.8519 113.926 9.15012 92.1721 9.15012 79.1195C9.15012 60.2657 33.8051 12.4061 51.2086 10.9558Z"
            fill="#E4EAED"
          />
          <path
            opacity="0.2581"
            d="M51.2086 12.4061C70.0623 10.9558 109.22 55.9148 104.869 84.9206C101.969 118.277 62.8109 125.529 41.0565 119.728C17.8519 113.926 9.15012 90.7218 9.15012 79.1195C9.15012 60.2657 33.8051 13.8564 51.2086 12.4061Z"
            fill="#E0E7EB"
          />
          <path
            opacity="0.2903"
            d="M51.2088 13.8563C68.6123 12.406 107.77 55.9148 103.419 84.9206C100.519 116.827 62.8111 124.078 41.0567 118.277C19.3024 112.476 10.6006 90.7218 10.6006 79.1194C9.15033 60.2657 33.8053 13.8563 51.2088 13.8563Z"
            fill="#DCE4E8"
          />
          <path
            opacity="0.3226"
            d="M49.7584 13.8563C68.6122 12.4061 104.869 55.9148 101.969 83.4703C97.618 115.377 61.3607 122.628 41.0566 118.277C19.3023 112.476 12.0508 90.7218 10.6005 79.1195C10.6005 60.2657 33.8052 15.3066 49.7584 13.8563Z"
            fill="#D8E1E6"
          />
          <path
            opacity="0.3548"
            d="M49.7584 15.3066C67.1619 13.8563 101.969 55.9148 99.0683 83.4703C96.1677 113.926 61.3607 121.178 41.0566 116.827C19.3023 111.026 12.0508 90.7218 10.6005 79.1194C10.6005 60.2657 33.8052 15.3066 49.7584 15.3066Z"
            fill="#D4DEE3"
          />
          <path
            opacity="0.3871"
            d="M49.7585 15.3066C65.7117 15.3066 100.519 55.9148 97.6181 82.02C94.7175 111.026 61.3608 119.728 41.0567 113.926C19.3024 108.125 12.0509 87.8212 12.0509 77.6692C12.0509 60.2657 33.8053 16.7569 49.7585 15.3066Z"
            fill="#D0DBE0"
          />
          <path
            opacity="0.4194"
            d="M49.7584 16.7569C64.2613 15.3066 97.618 55.9148 96.1677 82.02C93.2671 111.026 61.3607 118.277 42.5069 113.926C22.2029 109.576 13.5011 87.8212 13.5011 77.6691C12.0508 60.2657 33.8052 18.2072 49.7584 16.7569Z"
            fill="#CCD8DE"
          />
          <path
            opacity="0.4516"
            d="M48.3083 18.2072C62.8112 16.7569 96.1679 55.9148 93.2673 82.02C90.3667 108.125 59.9106 116.827 41.0568 112.476C20.7527 108.125 13.5013 87.8212 13.5013 77.6691C13.5013 60.2657 33.8054 18.2072 48.3083 18.2072Z"
            fill="#C8D5DB"
          />
          <path
            opacity="0.4839"
            d="M48.308 18.2072C62.8109 16.7569 94.7173 55.9148 91.8167 80.5697C88.9162 106.675 59.9103 115.377 41.0566 111.026C22.2028 106.675 14.9513 86.3709 14.9513 77.6692C13.501 60.2657 33.8051 19.6575 48.308 18.2072Z"
            fill="#C4D2D9"
          />
          <path
            opacity="0.5161"
            d="M48.3079 19.6575C62.8108 18.2072 91.8166 55.9148 90.3663 80.5697C86.0155 105.225 58.4599 113.926 41.0564 109.576C22.2027 105.225 14.9512 86.3709 14.9512 76.2189C14.9512 60.2657 35.2553 19.6575 48.3079 19.6575Z"
            fill="#C1CFD6"
          />
          <path
            opacity="0.5484"
            d="M46.8576 21.1078C61.3605 19.6575 90.3663 55.9148 87.4658 79.1194C84.5652 103.774 58.4599 111.026 41.0564 108.125C22.2027 103.774 16.4015 86.3709 14.9512 76.2188C14.9512 60.2656 35.2553 21.1078 46.8576 21.1078Z"
            fill="#BDCCD4"
          />
          <path
            opacity="0.5806"
            d="M46.8577 21.1078C59.9103 21.1078 87.4659 55.9148 84.5653 79.1194C83.115 102.324 58.46 109.576 41.0565 106.675C22.2027 103.774 16.4016 84.9206 16.4016 76.2188C16.4016 61.7159 35.2554 22.5581 46.8577 21.1078Z"
            fill="#B9C9D1"
          />
          <path
            opacity="0.6129"
            d="M46.8577 22.5581C58.46 22.5581 86.0156 55.9148 83.115 79.1194C80.2144 100.874 57.0097 108.125 41.0565 105.225C22.2027 102.324 16.4016 84.9206 16.4016 76.2189C16.4016 61.7159 35.2554 22.5581 46.8577 22.5581Z"
            fill="#B5C6CF"
          />
          <path
            opacity="0.6452"
            d="M45.4074 22.5581C57.0097 22.5581 83.115 55.9148 80.2144 77.6692C77.3138 99.4235 55.5594 106.675 41.0565 103.774C22.2027 100.874 17.8519 83.4703 16.4016 74.7686C16.4016 61.716 35.2554 24.0084 45.4074 22.5581Z"
            fill="#B1C3CC"
          />
          <path
            opacity="0.6774"
            d="M45.4075 24.0084C57.0098 24.0084 81.6648 55.9148 78.7642 77.6692C77.3139 97.9733 57.0098 105.225 41.0566 102.324C23.6532 100.874 17.852 83.4703 17.852 74.7686C17.852 61.716 35.2555 24.0084 45.4075 24.0084Z"
            fill="#ADC0C9"
          />
          <path
            opacity="0.7097"
            d="M45.4074 25.4587C55.5594 25.4587 80.2144 57.3651 77.3138 77.6692C75.8635 96.5229 55.5594 103.774 41.0565 102.324C23.653 99.4235 19.3022 82.02 19.3022 74.7686C17.8519 61.7159 35.2554 25.4587 45.4074 25.4587Z"
            fill="#A9BDC7"
          />
          <path
            opacity="0.7419"
            d="M45.4076 25.4587C55.5596 25.4587 77.314 55.9148 75.8637 76.2189C72.9631 93.6223 55.5596 102.324 41.0567 100.874C23.6532 97.9732 19.3023 82.02 19.3023 74.7686C19.3023 61.7159 35.2555 26.909 45.4076 25.4587Z"
            fill="#A5BAC4"
          />
          <path
            opacity="0.7742"
            d="M43.9573 26.909C52.659 26.909 74.4134 57.3651 72.9631 76.2189C71.5128 92.1721 55.5596 100.874 41.0567 99.4235C25.1035 96.5229 19.3023 80.5697 19.3023 74.7686C19.3023 61.716 35.2555 26.909 43.9573 26.909Z"
            fill="#A1B7C2"
          />
          <path
            opacity="0.8065"
            d="M43.9574 28.3592C52.6591 28.3592 72.9632 57.3651 71.5129 76.2188C70.0626 92.172 54.1094 100.874 42.5071 99.4235C25.1036 96.5229 20.7527 80.5697 20.7527 73.3183C20.7527 61.7159 35.2556 28.3592 43.9574 28.3592Z"
            fill="#9DB4BF"
          />
          <path
            opacity="0.8387"
            d="M43.9574 28.3592C52.6591 28.3592 71.5129 55.9148 70.0626 74.7686C68.6123 89.2715 55.5597 97.9732 42.5071 96.5229C25.1036 95.0726 20.7527 80.5697 20.7527 73.3183C20.7527 61.7159 35.2556 28.3592 43.9574 28.3592Z"
            fill="#9AB1BD"
          />
          <path
            opacity="0.871"
            d="M42.5067 29.8095C51.2085 29.8095 68.612 57.3651 67.1617 73.3183C65.7114 87.8212 54.1091 96.5229 41.0565 95.0726C25.1032 93.6224 22.2027 79.1194 22.2027 73.3183C22.2027 61.7159 35.2553 29.8095 42.5067 29.8095Z"
            fill="#96AEBA"
          />
          <path
            opacity="0.9032"
            d="M42.5067 29.8095C49.7582 29.8095 67.1617 55.9148 65.7114 73.3183C64.2611 86.3709 52.6588 95.0726 41.0565 93.6224C26.5535 92.1721 22.2027 79.1194 22.2027 73.3183C22.2027 61.7159 35.2553 31.2598 42.5067 29.8095Z"
            fill="#92ABB8"
          />
          <path
            opacity="0.9355"
            d="M42.5067 31.2598C48.3079 31.2598 64.2611 57.3651 62.8108 71.868C61.3605 84.9206 52.6588 92.1721 41.0565 92.1721C26.5535 92.1721 22.2027 77.6692 22.2027 71.868C22.2027 63.1663 35.2553 31.2598 42.5067 31.2598Z"
            fill="#8EA8B5"
          />
          <path
            opacity="0.9677"
            d="M41.0566 32.7101C46.8577 32.7101 61.3606 57.3651 59.9104 71.868C59.9104 83.4703 52.6589 90.7218 41.0566 90.7218C26.5537 90.7218 23.6531 77.6692 23.6531 71.868C23.6531 63.1662 35.2554 32.7101 41.0566 32.7101Z"
            fill="#8AA5B3"
          />
          <path
            d="M41.0566 32.7101C46.8577 32.7101 59.9104 57.3651 58.4601 70.4177C58.4601 82.02 51.2086 89.2715 41.0566 89.2715C26.5537 89.2715 23.6531 76.2189 23.6531 71.868C23.6531 63.1662 35.2554 32.7101 41.0566 32.7101Z"
            fill="#86A2B0"
          />
        </g>
        <path
          d="M59.9102 64.6165C59.9102 80.5697 46.8576 93.6224 30.9044 93.6224C14.9512 93.6224 0.448303 80.5697 0.448303 64.6165C0.448303 37.061 30.9044 0.803711 30.9044 0.803711H32.3547V2.254C39.6062 10.9558 59.9102 44.3125 59.9102 64.6165Z"
          fill="#C4F1FF"
        />
        <path
          d="M61.3607 66.0668C61.3607 82.02 48.3081 95.0726 32.3549 95.0726C16.4017 95.0726 3.34909 82.02 3.34909 66.0668C3.34909 42.8622 32.3549 0.803711 32.3549 0.803711C32.3549 0.803711 61.3607 41.4119 61.3607 66.0668Z"
          fill="url(#paint0_linear_2_2487)"
        />
        <g style={{ 'mix-blend-mode': 'multiply' }}>
          <path
            opacity="0.032258"
            d="M36.7059 141.481C51.2088 140.031 80.2147 171.937 77.3141 193.691C75.8638 218.346 43.9574 222.697 29.4545 218.346C13.5013 213.996 7.70011 196.592 6.24982 189.341C6.24982 173.387 23.6533 141.481 36.7059 141.481Z"
            fill="#FBFCFC"
          />
          <path
            opacity="0.064516"
            d="M36.7059 141.481C51.2088 140.031 78.7644 171.937 75.8638 192.241C72.9632 216.896 42.5071 221.247 28.0042 216.896C12.051 212.545 6.24982 196.592 6.24982 187.89C6.24982 173.387 23.6533 142.931 36.7059 141.481Z"
            fill="#F7F9FA"
          />
          <path
            opacity="0.096774"
            d="M36.706 141.482C49.7586 140.032 77.3142 170.488 75.8639 190.792C72.9633 215.447 43.9575 221.248 29.4546 216.897C13.5014 212.546 7.7002 196.593 7.7002 187.891C7.7002 173.388 23.6534 142.932 36.706 141.482Z"
            fill="#F3F6F7"
          />
          <path
            opacity="0.129"
            d="M36.706 142.932C49.7586 141.482 77.3142 171.938 74.4136 192.242C71.513 215.447 43.9575 221.248 29.4546 216.897C14.9517 212.546 7.7002 196.593 7.7002 189.342C7.7002 174.839 23.6534 142.932 36.706 142.932Z"
            fill="#EFF3F5"
          />
          <path
            opacity="0.1613"
            d="M36.706 142.932C49.7586 141.482 75.8639 171.938 72.9633 190.792C70.0627 213.997 43.9575 218.347 29.4546 215.447C14.9517 211.096 9.15049 196.593 7.7002 187.891C7.7002 174.839 23.6534 144.383 36.706 142.932Z"
            fill="#EBF0F2"
          />
          <path
            opacity="0.1935"
            d="M35.2556 144.383C48.3082 142.932 72.9632 171.938 71.5129 190.792C68.6123 212.546 42.5071 218.347 29.4544 213.997C14.9515 209.646 9.15036 195.143 9.15036 187.891C7.70007 174.839 23.6533 144.383 35.2556 144.383Z"
            fill="#E8EDF0"
          />
          <path
            opacity="0.2258"
            d="M35.2558 144.383C46.8582 142.932 72.9634 171.938 70.0628 190.792C67.1623 212.546 42.5073 216.897 29.4547 213.997C14.9518 209.646 9.1506 195.143 9.1506 187.891C9.1506 174.839 25.1038 144.383 35.2558 144.383Z"
            fill="#E4EAED"
          />
          <path
            opacity="0.2581"
            d="M35.2557 144.383C46.8581 142.932 71.513 171.938 68.6124 189.342C65.7118 209.646 41.0569 215.447 28.0043 211.096C13.5014 206.745 7.7002 193.692 7.7002 186.441C9.15049 174.839 25.1037 145.833 35.2557 144.383Z"
            fill="#E0E7EB"
          />
          <path
            opacity="0.2903"
            d="M35.2558 145.833C46.8581 144.383 70.0628 171.938 68.6125 190.792C65.7119 211.096 42.5073 215.447 29.4546 212.546C14.9517 208.195 10.6008 195.143 10.6008 187.891C9.15056 174.839 25.1038 145.833 35.2558 145.833Z"
            fill="#DCE4E8"
          />
          <path
            opacity="0.3226"
            d="M35.2558 145.833C46.8581 145.833 68.6125 171.938 67.1622 189.342C64.2616 209.646 42.5073 213.997 29.4546 211.096C16.402 208.195 10.6008 193.692 10.6008 186.441C9.15056 174.839 25.1038 147.283 35.2558 145.833Z"
            fill="#D8E1E6"
          />
          <path
            opacity="0.3548"
            d="M35.2555 147.283C45.4075 147.283 68.6122 171.938 65.7116 189.342C64.2613 208.195 41.0566 213.997 29.4543 209.646C16.4017 206.745 10.6005 192.242 10.6005 186.441C10.6005 174.839 25.1034 147.283 35.2555 147.283Z"
            fill="#D4DEE3"
          />
          <path
            opacity="0.3871"
            d="M33.8052 147.283C43.9572 145.833 65.7116 171.938 64.2613 189.342C62.811 208.195 41.0566 212.546 29.4543 209.646C16.4017 206.745 12.0508 193.692 10.6005 186.441C10.6005 174.839 25.1034 147.283 33.8052 147.283Z"
            fill="#D0DBE0"
          />
          <path
            opacity="0.4194"
            d="M33.8054 147.283C43.9574 147.283 64.2615 171.938 62.8112 187.891C61.3609 205.295 41.0568 211.096 29.4545 208.195C16.4019 205.295 12.051 192.242 12.051 186.441C10.6007 174.839 25.1036 148.733 33.8054 147.283Z"
            fill="#CCD8DE"
          />
          <path
            opacity="0.4516"
            d="M33.8053 148.733C43.9573 148.733 62.8111 171.938 61.3608 187.891C59.9105 205.295 39.6064 209.646 29.4544 206.745C16.4018 203.844 12.0509 190.792 12.0509 184.991C12.0509 174.839 25.1035 148.733 33.8053 148.733Z"
            fill="#C8D5DB"
          />
          <path
            opacity="0.4839"
            d="M33.8053 148.733C42.507 148.733 62.8111 171.938 61.3608 187.891C58.4602 203.844 39.6064 209.646 29.4544 206.745C16.4018 203.844 12.0509 192.242 12.0509 184.991C12.0509 174.839 25.1035 148.733 33.8053 148.733Z"
            fill="#C4D2D9"
          />
          <path
            opacity="0.5161"
            d="M33.8053 148.733C42.507 148.733 61.3608 171.938 59.9105 186.441C57.0099 203.844 39.6064 208.195 29.4544 205.295C17.8521 202.394 13.5012 190.792 12.0509 184.991C12.0509 174.839 25.1035 150.184 33.8053 148.733Z"
            fill="#C1CFD6"
          />
          <path
            opacity="0.5484"
            d="M32.355 150.184C41.0567 150.184 58.4602 171.938 57.0099 186.441C55.5596 202.394 38.1561 206.745 28.0041 203.844C16.4018 200.944 12.0509 189.342 12.0509 183.54C12.0509 174.839 25.1035 150.184 32.355 150.184Z"
            fill="#BDCCD4"
          />
          <path
            opacity="0.5806"
            d="M32.3551 150.184C41.0568 150.184 58.4603 171.938 57.01 186.441C55.5597 200.944 39.6065 205.295 29.4545 203.844C17.8522 200.944 13.5013 190.792 13.5013 184.991C13.5013 174.839 25.1036 151.634 32.3551 150.184Z"
            fill="#B9C9D1"
          />
          <path
            opacity="0.6129"
            d="M32.3551 151.634C39.6065 151.634 57.01 173.388 55.5597 186.441C54.1094 200.944 39.6065 205.295 29.4545 203.844C17.8522 202.394 13.5013 190.792 13.5013 184.991C13.5013 174.839 25.1036 151.634 32.3551 151.634Z"
            fill="#B5C6CF"
          />
          <path
            opacity="0.6452"
            d="M32.3552 151.634C39.6067 151.634 55.5599 171.938 54.1096 186.441C52.6593 199.494 38.1564 203.844 29.4547 202.394C17.8523 200.944 14.9517 189.342 14.9517 184.991C13.5015 174.839 25.1038 151.634 32.3552 151.634Z"
            fill="#B1C3CC"
          />
          <path
            opacity="0.6774"
            d="M32.3552 151.634C39.6066 151.634 54.1095 171.938 52.6592 184.991C51.2089 198.043 38.1563 202.394 29.4546 200.944C17.8522 199.494 14.9517 187.891 14.9517 183.54C14.9517 176.289 25.1037 153.084 32.3552 151.634Z"
            fill="#ADC0C9"
          />
          <path
            opacity="0.7097"
            d="M30.9049 153.084C38.1563 153.084 52.6592 173.388 51.2089 184.991C49.7586 196.593 38.1563 202.394 29.4546 200.944C17.8522 199.494 14.9517 189.342 14.9517 183.54C14.9517 176.289 25.1037 153.084 30.9049 153.084Z"
            fill="#A9BDC7"
          />
          <path
            opacity="0.7419"
            d="M30.9048 153.084C36.7059 153.084 51.2089 171.938 49.7586 184.991C48.3083 196.593 36.7059 200.944 28.0042 199.494C17.8522 198.043 13.5013 187.891 13.5013 183.54C14.9516 176.289 25.1036 153.084 30.9048 153.084Z"
            fill="#A5BAC4"
          />
          <path
            opacity="0.7742"
            d="M30.9049 154.535C36.706 154.535 49.7586 173.388 48.3084 184.991C46.8581 195.143 36.706 200.944 28.0043 199.494C17.8522 198.043 14.9517 187.891 14.9517 183.54C14.9517 176.289 25.1037 154.535 30.9049 154.535Z"
            fill="#A1B7C2"
          />
          <path
            opacity="0.8065"
            d="M30.9049 154.535C36.7061 154.535 49.7587 171.938 48.3084 183.54C46.8582 193.692 38.1564 198.043 29.4547 198.043C19.3026 196.593 16.402 187.891 16.402 183.54C16.402 176.289 25.1038 154.535 30.9049 154.535Z"
            fill="#9DB4BF"
          />
          <path
            opacity="0.8387"
            d="M30.9049 154.535C36.7061 154.535 48.3084 171.938 46.8582 183.54C45.4079 193.692 36.7061 198.043 29.4547 196.593C19.3026 195.143 16.402 186.441 16.402 182.09C16.402 176.289 25.1038 154.535 30.9049 154.535Z"
            fill="#9AB1BD"
          />
          <path
            opacity="0.871"
            d="M29.4547 155.985C33.8055 155.985 45.4079 173.388 43.9576 183.54C42.5073 192.242 35.2558 198.043 28.0044 196.593C17.8523 195.143 16.402 186.441 16.402 183.54C16.402 176.289 25.1038 155.985 29.4547 155.985Z"
            fill="#96AEBA"
          />
          <path
            opacity="0.9032"
            d="M29.4543 155.985C33.8052 155.985 43.9572 171.938 43.9572 182.09C42.5069 190.792 36.7058 195.143 29.4543 195.143C19.3023 195.143 17.852 186.441 17.852 182.09C17.852 176.289 25.1034 155.985 29.4543 155.985Z"
            fill="#92ABB8"
          />
          <path
            opacity="0.9355"
            d="M29.4543 157.435C33.8052 157.435 43.9572 173.388 42.5069 183.54C42.5069 190.792 35.2555 196.593 29.4543 196.593C20.7526 196.593 17.852 187.891 17.852 183.54C17.852 176.289 25.1034 157.435 29.4543 157.435Z"
            fill="#8EA8B5"
          />
          <path
            opacity="0.9677"
            d="M29.4543 157.435C33.8052 157.435 42.5069 173.388 41.0566 182.09C41.0566 189.342 35.2555 193.692 29.4543 193.692C20.7526 193.692 17.852 184.991 17.852 182.09C17.852 176.289 25.1034 157.435 29.4543 157.435Z"
            fill="#8AA5B3"
          />
          <path
            d="M29.4545 157.435C32.3551 157.435 41.0568 171.938 41.0568 182.09C41.0568 187.891 36.706 193.692 29.4545 193.692C20.7528 193.692 19.3025 184.991 19.3025 182.09C17.8522 176.289 25.1036 157.435 29.4545 157.435Z"
            fill="#86A2B0"
          />
        </g>
        <path
          d="M39.6064 177.739C39.6064 187.891 30.9046 195.143 22.2029 195.143C13.5011 195.143 3.34909 186.441 3.34909 177.739C3.34909 160.336 22.2029 138.581 22.2029 138.581H23.6532V140.032C28.004 144.383 39.6064 164.687 39.6064 177.739Z"
          fill="#C4F1FF"
        />
        <path
          d="M42.5068 179.19C42.5068 189.342 33.805 196.593 25.1033 196.593C14.9512 196.593 7.69977 187.891 7.69977 179.19C7.69977 164.687 25.1033 138.581 25.1033 138.581C25.1033 138.581 42.5068 163.236 42.5068 179.19Z"
          fill="url(#paint1_linear_2_2487)"
        />
        <g style={{ 'mix-blend-mode': 'multiply' }}>
          <path
            opacity="0.032258"
            d="M109.22 83.4703C126.624 82.02 161.431 119.728 158.53 144.383C155.629 174.839 117.922 180.64 100.518 174.839C81.6646 169.038 72.9629 150.184 72.9629 140.032C72.9629 122.628 93.2669 84.9206 109.22 83.4703Z"
            fill="#FBFCFC"
          />
          <path
            opacity="0.064516"
            d="M109.22 83.4703C125.173 82.02 159.98 119.728 157.08 144.383C154.179 173.388 117.922 179.19 100.518 174.839C81.6646 169.038 74.4132 150.184 72.9629 140.032C72.9629 122.628 93.2669 84.9206 109.22 83.4703Z"
            fill="#F7F9FA"
          />
          <path
            opacity="0.096774"
            d="M109.22 84.9206C125.173 83.4703 158.53 119.728 155.629 144.383C152.729 173.388 117.922 179.19 100.518 173.388C81.6643 167.587 74.4128 148.733 74.4128 140.032C72.9625 122.628 93.2666 86.3709 109.22 84.9206Z"
            fill="#F3F6F7"
          />
          <path
            opacity="0.129"
            d="M107.77 84.9206C123.723 83.4703 155.629 119.728 152.729 142.932C149.828 170.488 116.472 176.289 99.0681 171.938C81.6646 166.137 74.4132 148.733 72.9629 138.581C74.4132 122.628 93.2669 86.3709 107.77 84.9206Z"
            fill="#EFF3F5"
          />
          <path
            opacity="0.1613"
            d="M107.77 86.3709C122.272 84.9206 154.179 119.728 151.278 142.932C148.378 170.488 116.471 176.289 99.0678 170.488C81.6643 164.687 74.4128 147.283 74.4128 138.581C74.4128 122.628 93.2666 86.3709 107.77 86.3709Z"
            fill="#EBF0F2"
          />
          <path
            opacity="0.1935"
            d="M107.77 86.3709C122.273 84.9206 152.729 119.728 149.828 142.932C146.928 169.038 116.471 174.839 100.518 170.488C83.1147 166.137 75.8633 147.283 75.8633 138.581C74.413 122.628 93.2668 87.8212 107.77 86.3709Z"
            fill="#E8EDF0"
          />
          <path
            opacity="0.2258"
            d="M107.77 87.8212C122.272 86.3709 151.278 119.728 149.828 142.932C145.477 167.587 116.471 173.388 100.518 169.038C83.1146 164.687 77.3135 147.283 75.8632 138.581C75.8632 122.628 94.7169 87.8212 107.77 87.8212Z"
            fill="#E4EAED"
          />
          <path
            opacity="0.2581"
            d="M107.77 87.8212C122.273 86.3709 151.279 119.728 148.378 141.482C145.477 166.137 116.472 171.938 100.518 167.587C83.1149 163.236 77.3137 145.833 77.3137 137.131C75.8634 124.078 94.7172 89.2715 107.77 87.8212Z"
            fill="#E0E7EB"
          />
          <path
            opacity="0.2903"
            d="M106.319 89.2715C120.822 87.8212 148.378 119.728 145.477 141.482C142.577 166.137 115.021 171.938 99.0678 167.587C83.1146 163.236 75.8632 147.283 75.8632 138.581C75.8632 124.078 94.7169 89.2715 106.319 89.2715Z"
            fill="#DCE4E8"
          />
          <path
            opacity="0.3226"
            d="M106.319 89.2715C119.372 87.8212 146.927 119.728 144.027 141.482C141.126 164.687 115.021 170.488 99.0678 166.137C83.1146 161.786 77.3135 145.833 75.8632 137.131C77.3135 124.078 94.7169 90.7218 106.319 89.2715Z"
            fill="#D8E1E6"
          />
          <path
            opacity="0.3548"
            d="M106.319 90.7218C119.372 89.2715 145.477 119.728 142.577 140.032C139.676 163.236 113.571 169.038 99.0679 164.687C84.565 161.786 77.3135 145.833 77.3135 137.131C77.3135 124.078 94.717 90.7218 106.319 90.7218Z"
            fill="#D4DEE3"
          />
          <path
            opacity="0.3871"
            d="M106.319 90.7218C117.921 89.2715 144.027 119.728 142.576 140.032C139.676 161.786 115.021 167.587 100.518 164.687C84.5648 160.336 78.7636 144.383 78.7636 137.131C77.3133 124.078 94.7168 92.1721 106.319 90.7218Z"
            fill="#D0DBE0"
          />
          <path
            opacity="0.4194"
            d="M104.869 92.1721C116.472 92.1721 141.126 121.178 139.676 140.032C136.776 161.786 113.571 167.587 99.068 163.236C84.5651 160.336 78.7639 144.383 78.7639 137.131C78.7639 124.078 94.7171 92.1721 104.869 92.1721Z"
            fill="#CCD8DE"
          />
          <path
            opacity="0.4516"
            d="M104.869 92.1721C116.472 92.1721 139.676 121.178 138.226 140.032C135.325 160.336 113.571 166.137 99.068 163.236C84.5651 160.336 78.7639 144.383 78.7639 137.131C78.7639 124.078 94.7171 92.1721 104.869 92.1721Z"
            fill="#C8D5DB"
          />
          <path
            opacity="0.4839"
            d="M104.869 92.1721C115.021 92.1721 139.676 119.728 136.776 138.581C135.325 158.885 113.571 164.687 99.068 161.786C84.5651 158.885 78.7639 144.383 78.7639 137.131C78.7639 124.078 94.7171 93.6224 104.869 92.1721Z"
            fill="#C4D2D9"
          />
          <path
            opacity="0.5161"
            d="M104.869 93.6224C115.021 93.6224 138.226 121.178 135.325 138.581C133.875 157.435 112.121 163.236 99.068 160.336C84.5651 157.435 78.7639 142.932 78.7639 135.681C80.2142 124.078 94.7171 93.6224 104.869 93.6224Z"
            fill="#C1CFD6"
          />
          <path
            opacity="0.5484"
            d="M103.419 93.6224C113.571 93.6224 135.325 119.728 133.875 137.131C132.425 154.535 112.12 161.786 100.518 158.885C86.0153 155.985 81.6644 141.482 81.6644 135.681C80.2141 124.078 94.717 95.0727 103.419 93.6224Z"
            fill="#BDCCD4"
          />
          <path
            opacity="0.5806"
            d="M103.419 95.0727C113.571 95.0727 133.875 121.178 132.425 138.581C130.975 154.535 112.121 160.336 99.0681 158.885C84.5652 155.985 80.2143 142.932 80.2143 135.681C80.2143 124.078 94.7172 95.0727 103.419 95.0727Z"
            fill="#B9C9D1"
          />
          <path
            opacity="0.6129"
            d="M103.419 95.0727C112.12 95.0727 132.424 119.728 130.974 137.131C129.524 153.084 112.12 158.885 100.518 157.435C86.0151 154.535 81.6642 141.482 81.6642 135.681C81.6642 124.078 94.7169 96.523 103.419 95.0727Z"
            fill="#B5C6CF"
          />
          <path
            opacity="0.6452"
            d="M103.419 96.5229C112.121 96.5229 130.974 121.178 129.524 137.131C128.074 153.084 110.67 158.885 100.518 157.435C87.4657 154.535 83.1148 141.482 83.1148 135.681C81.6645 124.078 94.7171 96.5229 103.419 96.5229Z"
            fill="#B1C3CC"
          />
          <path
            opacity="0.6774"
            d="M103.419 96.5229C112.121 96.5229 129.524 121.178 128.074 135.681C126.624 150.184 110.67 155.985 100.518 154.535C87.4657 153.084 83.1148 140.032 83.1148 134.231C81.6645 124.078 94.7171 96.5229 103.419 96.5229Z"
            fill="#ADC0C9"
          />
          <path
            opacity="0.7097"
            d="M101.968 97.9732C109.22 97.9732 126.623 121.178 125.173 137.131C123.723 151.634 109.22 157.435 99.0677 155.985C86.0151 154.535 81.6642 141.482 81.6642 135.681C83.1145 124.078 94.7169 97.9732 101.968 97.9732Z"
            fill="#A9BDC7"
          />
          <path
            opacity="0.7419"
            d="M101.968 97.9732C109.22 97.9732 126.623 121.178 125.173 135.681C123.723 148.733 110.67 154.535 100.518 153.084C87.4655 151.634 83.1146 140.032 83.1146 134.231C83.1146 125.529 94.717 97.9732 101.968 97.9732Z"
            fill="#A5BAC4"
          />
          <path
            opacity="0.7742"
            d="M101.968 99.4235C109.22 99.4235 125.173 121.178 123.723 135.681C122.272 148.733 110.67 154.535 100.518 153.084C87.4655 151.634 83.1146 140.032 83.1146 134.231C83.1146 125.529 94.717 99.4235 101.968 99.4235Z"
            fill="#A1B7C2"
          />
          <path
            opacity="0.8065"
            d="M101.968 99.4235C107.77 99.4235 123.723 121.178 122.273 134.231C120.822 145.833 109.22 151.634 100.518 151.634C87.4656 150.184 84.565 138.581 84.565 134.231C84.565 125.529 94.717 99.4235 101.968 99.4235Z"
            fill="#9DB4BF"
          />
          <path
            opacity="0.8387"
            d="M100.518 100.874C106.319 100.874 120.822 121.178 119.372 134.231C117.922 145.833 107.77 151.634 99.0679 150.184C87.4656 148.733 84.565 138.581 84.565 132.78C84.565 125.529 94.717 100.874 100.518 100.874Z"
            fill="#9AB1BD"
          />
          <path
            opacity="0.871"
            d="M100.518 100.874C106.319 100.874 119.372 121.178 117.922 134.231C116.471 144.383 107.77 150.184 99.0679 150.184C87.4656 148.733 84.565 138.581 84.565 134.231C84.565 125.529 94.717 100.874 100.518 100.874Z"
            fill="#96AEBA"
          />
          <path
            opacity="0.9032"
            d="M100.518 100.874C106.319 100.874 117.922 121.178 117.922 132.78C116.471 142.932 107.77 148.733 99.0679 148.733C87.4656 148.733 84.565 137.131 84.565 132.78C86.0153 125.529 94.717 102.324 100.518 100.874Z"
            fill="#92ABB8"
          />
          <path
            opacity="0.9355"
            d="M100.518 102.324C104.869 102.324 116.471 121.178 116.471 132.78C115.021 141.482 109.22 147.283 100.518 147.283C88.9159 147.283 87.4656 137.131 87.4656 132.78C86.0153 125.529 94.7171 102.324 100.518 102.324Z"
            fill="#8EA8B5"
          />
          <path
            opacity="0.9677"
            d="M100.518 102.324C104.869 102.324 116.471 121.178 115.021 131.33C115.021 140.032 107.77 145.833 100.518 145.833C90.3662 145.833 87.4656 135.681 87.4656 131.33C86.0153 125.529 96.1673 102.324 100.518 102.324Z"
            fill="#8AA5B3"
          />
          <path
            d="M99.0681 103.774C103.419 103.774 113.571 121.178 112.121 132.78C112.121 140.032 106.32 145.833 99.0681 145.833C88.9161 145.833 87.4658 135.681 87.4658 132.78C87.4658 125.529 96.1675 103.774 99.0681 103.774Z"
            fill="#86A2B0"
          />
        </g>
        <path
          d="M113.571 126.979C113.571 138.581 103.419 148.733 91.8164 148.733C80.2141 148.733 70.0621 138.581 70.0621 126.979C70.0621 106.675 91.8164 80.5697 91.8164 80.5697L93.2667 79.1194V80.5697C97.6176 87.8212 113.571 112.476 113.571 126.979Z"
          fill="#C4F1FF"
        />
        <path
          d="M115.021 128.429C115.021 140.032 104.869 150.184 93.2668 150.184C81.6645 150.184 71.5125 140.032 71.5125 128.429C71.5125 111.026 93.2668 80.5697 93.2668 80.5697C93.2668 80.5697 115.021 109.576 115.021 128.429Z"
          fill="url(#paint2_linear_2_2487)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_2_2487"
            x1="6.35119"
            y1="27.3063"
            x2="59.3564"
            y2="80.3116"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#6BD9FF" />
            <stop offset="1" stopColor="#3EC9F7" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_2_2487"
            x1="7.24728"
            y1="154.295"
            x2="40.3777"
            y2="187.424"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#6BD9FF" />
            <stop offset="1" stopColor="#3EC9F7" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_2_2487"
            x1="73.6183"
            y1="99.2756"
            x2="113.044"
            y2="138.7"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#6BD9FF" />
            <stop offset="1" stopColor="#3EC9F7" />
          </linearGradient>
        </defs>
      </svg>
    </div>
  );
}

export default rainy;
